import React, { useState, useRef } from 'react'
import { callAPI } from 'helpers'

// Components
import CustomModal from 'components/CustomModal'
import QuestionForm from './QuestionForm'
import { message } from 'antd'

export default ({ examId, questionNo, visible, onCreate, onCancel }) => {
  const questionFormRef = useRef()
  const [creating, setCreating] = useState()

  const _onQuestionCreate = async () => {
    const formData = questionFormRef.current.getFormData()
    if (!formData) return
    try {
      setCreating(true)
      const imageURLs = await questionFormRef.current.uploadAllFiles()
      const { result: newQuestion } = await callAPI({
        method: 'POST',
        url: `/exams/${examId}/questions`,
        body: {
          ...formData,
          ...imageURLs,
          sequence: questionNo
        }
      })
      setCreating(false)
      message.success(`เพิ่มคำถามที่ ${questionNo} สำเร็จ`)
      onCreate(newQuestion)
      questionFormRef.current.clear()
    } catch (error) {
      console.error('Error while trying to create new question.', error)
      message.error(`เพิ่มคำถามที่ ${questionNo} ไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง`)
      setCreating(false)
    }
  }

  return (
    <CustomModal visible={visible}
      cancelText='ย้อนกลับ'
      okText='เพิ่มคำถาม'
      okButtonProps={{
        loading: creating,
        icon: 'plus'
      }}
      onCancel={onCancel}
      onOk={_onQuestionCreate}>
      <QuestionForm
        ref={questionFormRef}
        questionNo={questionNo} />
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/components/exams/QuestionCreateModal.js